import { createContext } from 'react';
export const AccessCheckDropdownContext = /*#__PURE__*/createContext({
  accessInfoMap: new Map(),
  hasAllGates: true
});